import type { JSX } from "react";

/**
 * The password-visibility toggle glyphs for the sign-in card, extracted from
 * `LoginPage.tsx`. Decorative (`aria-hidden`) — the toggle button carries the
 * accessible label.
 */
export function EyeIcon(): JSX.Element {
  return (
    <svg
      viewBox="0 0 20 20"
      width={16}
      height={16}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M1.5 10s3-6 8.5-6 8.5 6 8.5 6-3 6-8.5 6S1.5 10 1.5 10Z" />
      <circle cx="10" cy="10" r="2.5" />
    </svg>
  );
}

export function EyeOffIcon(): JSX.Element {
  return (
    <svg
      viewBox="0 0 20 20"
      width={16}
      height={16}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M3 3l14 14" />
      <path d="M9.3 4.1A8.6 8.6 0 0 1 10 4c5.5 0 8.5 6 8.5 6a16 16 0 0 1-2.4 3.2" />
      <path d="M6.4 6.1C3.7 7.6 1.5 10 1.5 10s3 6 8.5 6c1.5 0 2.9-.4 4-1" />
      <path d="M7.7 7.7a3 3 0 0 0 4.2 4.2" />
    </svg>
  );
}
